import { render, staticRenderFns } from "./Neraca.vue?vue&type=template&id=66db320e"
import script from "./Neraca.vue?vue&type=script&lang=js"
export * from "./Neraca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports